import { customEvent } from "goi_common";
import { useEffect, useState } from "react";

/**
 * 공통 견적 LP CTA
 * - 목적지: www.goifuneral.co.kr/match/request/?{원본 utm / n_ / NaPm}
 * - parlor_id 없음 (장례식장 특정 X)
 * - SSG 시점엔 window 없음 → useEffect로 클라이언트에서 search 합성
 */

const MATCH_BASE_URL = "https://www.goifuneral.co.kr/match/request";

function buildCtaHref(originalSearch: string): string {
  const base = `${MATCH_BASE_URL}/`;
  if (!originalSearch || originalSearch === "?") return base;
  return `${base}${originalSearch}`;
}

export const CommonQuoteCta = () => {
  const [ctaHref, setCtaHref] = useState(`${MATCH_BASE_URL}/`);

  useEffect(() => {
    setCtaHref(buildCtaHref(window.location.search));
  }, []);

  const handleCtaClick = () => {
    customEvent({
      newGtm: {
        path: "funeral_cost_ad",
        trigger_and_target: "btn_cta_quote",
      },
    });
  };

  return (
    <section className="lp-pitch">
      <p className="lp-pitch-copy">
        장례식장 빈소, 음식, 용품 이용료를 포함한 비용을
        <br />
        <span className="hl">1분만에</span> 확인해보세요.
      </p>
      <a className="lp-cta" href={ctaHref} onClick={handleCtaClick}>
        상세 비용 알아보기
        <span className="arrow">→</span>
      </a>
      <div className="lp-cta-sub">
        <span>비용 견적 무료 제공</span>
      </div>
    </section>
  );
};
